import React, { useContext } from "react";
import styled, { css } from "styled-components";
import formatMetric from "../util/formatMetric";
import ForwardersContext from "../forwarders/ForwardersContext";
const StyledThroughput = styled.dl(
  ({ theme }) => css`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    @media all and (max-width: ${theme.breakpoints.min.lg}) {
      flex-direction: column;
    }

    > dd {
      min-width: 220px;
    }
  `
);
const ForwarderThroughput = ({ forwarderId }) => {
  const { getForwarderContext } = useContext(ForwardersContext);
  const { metrics: forwarderMetrics } = getForwarderContext(forwarderId);
  if (!forwarderMetrics || forwarderMetrics.length === 0) {
    return /* @__PURE__ */ React.createElement("div", null, "No metrics available");
  }
  const {
    rate: { one_minute: oneMinute, five_minute: fiveMinute, fifteen_minute: fifteenMinute }
  } = forwarderMetrics[0];
  return /* @__PURE__ */ React.createElement(StyledThroughput, null, /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(oneMinute) && `1 minute average: ${formatMetric(oneMinute)} msg/s`, " "), /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(fiveMinute) && `5 minute average: ${formatMetric(fiveMinute)} msg/s`, " "), /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(fifteenMinute) && `15 minute average: ${formatMetric(fifteenMinute)} msg/s`, " "));
};
export default ForwarderThroughput;
